export enum PreloadType {
    Always = 'always',
    Public = 'public',
    Private = 'private',
}
